import Nullstack from 'nullstack';
export default function IconSitemapOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-sitemap-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("rect", {
    x: "3",
    y: "15",
    width: "6",
    height: "6",
    rx: "2"
  }), "   ", Nullstack.element("path", {
    d: "M19 15a2 2 0 0 1 2 2m-.591 3.42c-.362 .358 -.86 .58 -1.409 .58h-2a2 2 0 0 1 -2 -2v-2c0 -.549 .221 -1.046 .579 -1.407"
  }), "   ", Nullstack.element("path", {
    d: "M9 5a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2"
  }), "   ", Nullstack.element("path", {
    d: "M6 15v-1a2 2 0 0 1 2 -2h4m4 0a2 2 0 0 1 2 2"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}